export default import.meta.ROLLDOWN_FILE_URL_tprpW2DQ7716zBOy1ARFww